<template>
  <div class="charge-manage">
    <ListHeader class="questionnaire-data-header" :showVipMessage="false" :listTitle="'开票申请'"></ListHeader>
    <div class="search-wrapper">
      <span class="text">申请单号：</span>
      <el-input size="mini" v-model="applyNumber"></el-input>
      <span class="text">单位名称：</span>
      <el-input size="mini" v-model="publishUnit"></el-input>
      <el-button class="search-btn" size="mini" @click="getDataList">搜索</el-button>
      <el-button class="reset-btn" size="mini" @click="reset">重置</el-button>
    </div>
    <div class="module-list">
      <List class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
        <template v-slot:listContent>
          <div class="paper-list-content">
            <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
              <el-table-column prop="applyNumber" label="申请单号" min-width="100"></el-table-column>
              <el-table-column prop="applyAccount" label="申请账号" min-width="50"> </el-table-column>
              <el-table-column prop="publishUnit" label="单位名称" min-width="50"> </el-table-column>
              <el-table-column prop="invoiceAmount" label="开票金额" min-width="50"></el-table-column>
              <el-table-column prop="orderQuantity" label="订单数量" min-width="50"></el-table-column>
              <el-table-column prop="type" label="发票类型" min-width="50"></el-table-column>
              <el-table-column prop="status" label="开票状态" min-width="50">
                <template slot-scope="scope">
                  <span :class="{ red: scope.row.invoiceStatus === 0 }">{{ scope.row.invoiceStatus === 1 ? '已开票' : '未开票' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="250">
                <template slot-scope="scope">
                  <div class="option-button" @click="showOrder(scope.row.id)">查看订单</div>
                  <div class="option-button" @click="showInvoice(scope.row.invoiceInfo)">开票信息</div>
                  <div class="option-button" @click="showAddress(scope.row.address)">收票地址</div>
                  <div class="option-button" @click="showStatusDialog(scope.row.id)">状态变更</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </List>
    </div>
    <order-list ref="orderList" :invoice-id="currentId"></order-list>
    <invoice-info ref="invoiceInfo" :invoice="currentInvoice"></invoice-info>
    <address-info ref="addressInfo" :address="currentAddress"></address-info>
    <tip-dialog ref="statusDialog" :dialog-options="confirmDialogOptions" @clickConfirm="updateStatus" :appendToBody="true"></tip-dialog>
  </div>
</template>

<script>
import ListHeader from '@components/list/listHeader'
import List from '@components/list/listFrame'
import apis from '@api/invoice'
import OrderList from './components/OrderList'
import InvoiceInfo from '@components/InvoiceManagement/components/InvoiceInfo'
import AddressInfo from '@components/InvoiceManagement/components/AddressInfo'
import TipDialog from '@components/common/TipDialog'
export default {
  name: 'InvoiceManagement',
  data() {
    return {
      publishUnit: '',
      applyNumber: '',
      totalCount: 0,
      tableData: [],
      currentPageNo: 1,
      currentId: 0,
      currentInvoice: {},
      currentAddress: {},
      confirmDialogOptions: {
        type: 'confirm',
        confirmText: '是',
        cancelText: '否',
        title: '提示',
        tip: '是否已将发票发送给申请者？'
      }
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  watch: {
    currentModule() {
      this.currentPageNo = 1
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      const params = {
        pageNo: this.currentPageNo,
        pageSize: 10,
        applyNumber: this.applyNumber,
        publishUnit: this.publishUnit
      }
      apis.findpublishUnitInvoiceManageByPage(params).then((res) => {
        if (res.data && res.data.data?.page) {
          let list = res.data.data.page.result
          this.tableData = list.map((item) => {
            return {
              ...item,
              type: item.invoiceType === 1 ? '专业发票' : '普通发票'
            }
          })
          this.totalCount = res.data.data.page.totalCount
        }
      })
    },
    reset() {
      this.publishUnit = ''
      this.applyNumber = ''
      this.currentPageNo = 1
      this.getDataList()
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getDataList()
    },
    showOrder(id) {
      this.currentId = id
      this.$refs.orderList.dialogVisible = true
    },
    showStatusDialog(id) {
      this.currentId = id
      this.$refs.statusDialog.visible = true
    },
    showInvoice(invoiceInfo) {
      this.currentInvoice = JSON.parse(invoiceInfo)
      this.$refs.invoiceInfo.dialogVisible = true
    },
    showAddress(address) {
      this.currentAddress = JSON.parse(address)
      this.$refs.addressInfo.dialogVisible = true
    },
    updateStatus() {
      apis.updateInvoiceStatus(this.currentId).then((res) => {
        if (res.data.status === 0) {
          this.getDataList()
        } else {
          this.$message({
            message: '更新失败',
            type: 'error'
          })
        }
      })
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    }
  },
  components: {
    TipDialog,
    AddressInfo,
    InvoiceInfo,
    OrderList,
    ListHeader,
    List
  }
}
</script>

<style lang="scss" scoped>
.charge-manage {
  width: 100%;
  height: 100%;
  padding: 0 28px 18px 18px;
  position: relative;
  .search-wrapper {
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 14px;
    position: absolute;
    top: 8px;
    right: 30px;
    .el-input {
      width: 150px;
      margin-right: 20px;
    }
    .search-btn {
      background-color: #df5813;
      color: #fff;
      border-radius: 5px;
    }
    .reset-btn {
      background-color: #999999;
      color: #fff;
      border-radius: 5px;
    }
  }
}
</style>
<style lang="scss">
.charge-manage {
  .search-wrapper {
  }
  .module-list {
    .option-button {
      display: inline-block;
      cursor: pointer;
      color: #df5813;
      margin-right: 20px;
    }
    .common-list-wrapper {
      .page-component {
        margin: 0;
        bottom: 20px;
      }
      .common-list {
        .paper-list-content {
          .el-table {
            .red {
              color: #df5813;
            }
          }
        }
      }
    }
  }
}
</style>
